import React, { useState, useEffect, useContext } from "react";
import { PiShoppingCartThin, PiShoppingCartFill } from "react-icons/pi";
import AuthContext from '../../context/AuthContext';
import { useCount } from "../../context/CountContext";
import { TransferBasket } from "../../api/styleJewelleryService";
import useCartHandler from "../../utils/HandleCart";

const CartListIcon = ({
    size,
    fill = "var(--text-primary)",
    Style_ID,
    JewelCode,
    StyleNo,
    Quantity = 1,
    isincart,
    iswishlist,
    Cart_ID,
    fetchData,
    onUpdateCart,
    onTransfer,
    isProcessing,
    setIsProcessing,
}) => {
    const { user, showToast } = useContext(AuthContext);
    const isLoggedIn = user?.isAuthenticated;
    const { fetchStyleCartCount, fetchWishlistCount } = useCount();
    const [IS_AddedInCart, setIsCart] = useState("NO");
    const { HandleCartInsert } = useCartHandler();
    const [currentCartID, setCurrentCartID] = useState(Cart_ID);

    useEffect(() => {
        const isTrue = (val) => ["YES", "TRUE", "1", "Y"].includes(String(val ?? "").toUpperCase());
        setIsCart(isTrue(isincart) ? "YES" : "NO");
        setCurrentCartID(Cart_ID);
    }, [isincart, Cart_ID]);

    const getStringValue = (value) => (value === null || value === undefined ? "" : String(value));

    const handleCartInsert = async () => {
        if (isProcessing) return;
        setIsProcessing(true);

        const { success, message, titleMessage, type, newBasketID } = await HandleCartInsert({
            request: {
                Party_ID: user?.SelectedCustomer_ID,
                Style_ID: getStringValue(Style_ID),
                JewelCode: getStringValue(JewelCode),
                StyleNo: getStringValue(StyleNo),
                Quantity: getStringValue(Quantity),
                Rate: "0",
            }
        });

        if (success) {
            setIsCart("YES");
            setCurrentCartID(newBasketID);
            onUpdateCart?.(Style_ID, newBasketID);
            fetchStyleCartCount(user?.SelectedCustomer_ID);
            showToast({
                title: titleMessage || "Success",
                message: message || "Item added to cart.",
                type: "success"
            });
        } else {
            showToast({
                title: "Error",
                message: message || "Failed to add item to cart.",
                type: type || "error",
            });
        }
        setIsProcessing(false);
    };

    const handleCartToggle = async () => {
        if (!isLoggedIn) {
            showToast({
                title: "Validation",
                message: "Please log in to manage your cart.",
                type: "warning",
            });
            return;
        }

        if (!user?.SelectedCustomer_ID || user?.SelectedCustomer_ID === 0) {
            showToast({
                title: "Validation",
                message: "Please select a specific customer to manage your cart.",
                type: "warning",
            });
            return;
        }
        if (isProcessing) return;

        const isTrue = (val) => ["YES", "TRUE", "1", "Y"].includes(String(val ?? "").toUpperCase());
        
        if (isTrue(IS_AddedInCart)) {
            showToast({
                title: "Info",
                message: "Item is already in your cart.",
                type: "info"
            });
            return;
        }

        setIsProcessing(true);
        const inWishlist = isTrue(iswishlist);

        try {
            if (inWishlist) {
                const response = await TransferBasket({
                    Party_ID: user?.SelectedCustomer_ID,
                    Style_ID: getStringValue(Style_ID)
                });

                if (response?.Message?.[0]?.RETURNCODE === "1") {
                    const { RETURNMESSAGE, RETURNMESSAGETITLE } = response.Message[0];
                    const transferID = response.InsertWishlist?.at(-1)?.Basket_ID;
                    
                    setIsCart("YES");
                    setCurrentCartID(transferID);
                    onTransfer?.(Style_ID, transferID, 'cart');
                    fetchStyleCartCount(user?.SelectedCustomer_ID);
                    fetchWishlistCount(user?.SelectedCustomer_ID);
                    
                    showToast({
                        title: RETURNMESSAGETITLE || "Success",
                        message: RETURNMESSAGE || "Item transferred to cart.",
                        type: "success"
                    });
                } else {
                    throw new Error(response?.Message?.[0]?.RETURNMESSAGE || "Transfer failed");
                }
            } else {
                setIsProcessing(false); // Reset so handleCartInsert can set it
                await handleCartInsert();
            }
        } catch (error) {
            console.error("Cart action error:", error);
            showToast({
                title: "Error",
                message: error.message || "An error occurred.",
                type: "error",
            });
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div className="cart_icon">
            <button
                className={`cart_button ${IS_AddedInCart === "YES" ? "in_cart" : "not_in_cart"}`}
                disabled={isProcessing}
                style={{ background: "none", border: "none", cursor: isProcessing ? 'not-allowed' : 'pointer', opacity: isProcessing ? 0.6 : 1 }}
                onClick={(e) => {
                    e.stopPropagation();
                    handleCartToggle();
                }}
            >
                {IS_AddedInCart === "YES" ? (
                    <PiShoppingCartFill fill={fill} size={size} />
                ) : (
                    <PiShoppingCartThin fill={fill} size={size} />
                )}
            </button>
        </div>
    );
};

export default CartListIcon;
